import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
import { socket } from '../../../../index';
import { download } from '../../../sc-utilities/download.utils';
import config from '../../../../config/config';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'components',
    pluginName: 'PRODUCT',
    entityName: 'STORAGE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

export const fetchStorageInit = () => {
    return crudActions.fetchInit();
};
export const fetchStorageStart = () => {
    return crudActions.fetchStart();
};
export const fetchStorageSuccess = (fetchStorageCount, listStorageCount) => {
    return crudActions.fetchSuccess(fetchStorageCount, listStorageCount);
};
export const fetchStorageFail = () => {
    return crudActions.fetchFail();
};


export const fetchStorageCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchStorageStart());
        try {
            let countRes = await rest.post("components/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchStorageSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchStorageFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch storage."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchStorageFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch storage."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchStorage = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchStorageStart());
        try {
            let listRes = await rest.post("components/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchStorageSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchStorageFail());
            return []

        } catch (error) {
            dispatch(fetchStorageFail());
            return []
        }
    }
}

export const fetchErasureMethod = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customer-erasure-method/list', { listAll: true, formatForWEBUI: true, ...params });
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch securaze standards."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}
// Load storage action creators
export const loadStorageInit = () => {
    return crudActions.loadInit();
};
export const loadStorageStart = () => {
    return crudActions.loadStart();
};
export const loadStorageSuccess = loadedStorage => {
    return crudActions.loadSuccess(loadedStorage);
};
export const loadStorageFail = error => {
    return crudActions.loadFail(error);
};
export const loadStorage = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};


// Create Storage  action creators
export const createStorageInit = () => {
    return crudActions.createInit();
};
export const createStorageStart = () => {
    return crudActions.createStart();
};
export const createStorageSuccess = createdStorage => {
    return crudActions.createSuccess(createdStorage);
};
export const createStorageFail = error => {
    return crudActions.createFail(error);
};

export const createStorage = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createStorageStart());
        try {
            let res = await rest.post('/components/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createStorageSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created storage.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createStorageFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create storage."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create storage."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createStorageFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit Storage  action creators
export const editStorageInit = () => {
    return crudActions.editInit();
};
export const editStorageStart = () => {
    return crudActions.editStart();
};
export const editStorageSuccess = editedStorage => {
    return crudActions.editSuccess(editedStorage);
};
export const editStorageFail = error => {
    return crudActions.editFail(error);
};
export const editStorage = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editStorageStart());
        try {
            let res = await rest.post('/components/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editStorageSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated storage.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editStorageFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit storage."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit storage."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editStorageFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete storage action creators
export const bulkDeleteStoragesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteStoragesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteStoragesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteStoragesFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteStorages = storageIds => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, storageIds);
    };
};

// Delete storage  action creators
export const deleteStorageInit = () => {
    return crudActions.deleteInit();
};
export const deleteStorageStart = () => {
    return crudActions.deleteStart();
};
export const deleteStorageSuccess = deletedStorage => {
    return crudActions.deleteSuccess(deletedStorage);
};
export const deleteStorageFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteStorage = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

// custom functions
export const fetchUsers = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/users/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const users = [];
                for (var user of res.data.result.data) {
                    users.push({ value: user.UserID, displayValue: user.Username });
                }
                return users;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

export const generateReport = (storageProduct, translations) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            console.log(socket.id);
            storageProduct['SocketID'] = socket.id.split('#')[1];
            dispatch({ type: 'START_GENERATE' });
            snackActions.snackBar({
                message: translations['generating_report'] || `Erasure report generation started.`,
                options: {
                    variant: 'success'
                }
            });
            let res = await rest.post('report/generate', storageProduct);
            if (res.data && res.data.succeeded) {
                const redisTopic = res.data.result.data.RedisTopic;
                socket.once(redisTopic, async msg => {
                    const { Message, Status, ErasureReportID } = msg;
                    if (Status !== 'generated') {
                        snackActions.snackBar({
                            message: Message ?? (translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`),
                            options: {
                                variant: 'error'
                            }
                        });
                        dispatch({ type: 'FINISH_GENERATE' });
                        return false;
                    }
                    const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${storageProduct.ActiveCustomerID}`;
                    await download(objUrl);
                    snackActions.snackBar({
                        message: translations['generating_report'] || `Erasure report generation finished.`,
                        options: {
                            variant: 'success'
                        }
                    });
                    dispatch({ type: 'FINISH_GENERATE' });
                });
            }
            else {
                snackActions.snackBar({
                    message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const destroyStorage = data => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/products/storageProduct/destroyDisk', data);
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            return response ? response : false;
        } catch (error) {
            return false;
        }
    }
}
export const setStorages = (data) => {
    return ({
        type: 'HANDLE_STORAGE',
        storages: { ...data, fromProduct: true }
    });
}

export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}
